module.exports = __webpack_public_path__ + "static/media/1.13cc9a54.jpg";